import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ENV } from '@app/env';
import { Observable } from 'rxjs/Observable';
import { Utilities } from './utilities';

@Injectable()
export class XlsxData {

  constructor(
    private http: HttpClient,
    private utilities: Utilities
  ) { }

  public sendToXslxEndpoint(endpoint: String, file: File, sheets: String[]) {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);

    for (var index = 0; index < sheets.length; index++) {
      let sheet = sheets[index] + "";
      if (sheet.length > 0) {
        formData.append('sheet', sheet);
      }
    }
    this.utilities.consoleDecorator('Process file', `${ENV.fileServerXlsxToJson}/rebus-api-xls/rest/validar${endpoint}`);
    return this.http.post(`${ENV.fileServerXlsxToJson}/rebus-api-xls/rest/validar/${endpoint}`, formData)
      .catch(err => Observable.of(err.status) || 'Server error');
  }
}


// WEBPACK FOOTER //
// ./src/providers/xlsx.ts